import React, { memo, useMemo } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import LiveTvIcon from "@mui/icons-material/LiveTv";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import {
  youtubeEmbedUrl,
} from "../../../utils/youtubeEmbed";

const red = "#d93349";

function FinalNightLiveStream({ youtubeUrl }) {
  const embedSrc = useMemo(() => {
    const origin =
      typeof window !== "undefined" ? window.location.origin : undefined;
    return youtubeEmbedUrl(youtubeUrl, { origin });
  }, [youtubeUrl]);

  if (!youtubeUrl) return null;

  if (!embedSrc) {
    return (
      <Box className="fn-live-wrap">
        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 1.5 }}>
          <LiveTvIcon sx={{ color: red }} />
          <Typography sx={{ color: "#fff", fontWeight: 700 }}>
            Live stream
          </Typography>
        </Stack>
        <Box
          className="fn-live-frame fn-live-fallback"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 200,
            p: 3,
            textAlign: "center",
          }}
        >
          <Stack spacing={2} alignItems="center">
            <Typography sx={{ color: "rgba(255,255,255,0.75)", maxWidth: 420 }}>
              This link cannot be embedded. Open the stream directly on YouTube
              (use a watch or /live/VIDEO_ID link from YouTube Studio).
            </Typography>
            <Button
              variant="contained"
              href={youtubeUrl}
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<OpenInNewIcon />}
              sx={{
                bgcolor: red,
                fontWeight: 700,
                textTransform: "none",
                "&:hover": { bgcolor: "#b8283a" },
              }}
            >
              Watch on YouTube
            </Button>
          </Stack>
        </Box>
      </Box>
    );
  }

  return (
    <Box className="fn-live-wrap">
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={1}
        sx={{ mb: 1.5 }}
      >
        <Stack direction="row" alignItems="center" gap={1}>
          <LiveTvIcon sx={{ color: red }} />
          <Typography sx={{ color: "#fff", fontWeight: 700 }}>
            Live stream
          </Typography>
        </Stack>
        <Button
          size="small"
          href={youtubeUrl}
          target="_blank"
          rel="noopener noreferrer"
          startIcon={<OpenInNewIcon sx={{ fontSize: 16 }} />}
          sx={{
            color: "rgba(255,255,255,0.65)",
            textTransform: "none",
            fontSize: 13,
            "&:hover": { color: "#fff", bgcolor: "rgba(255,255,255,0.06)" },
          }}
        >
          Open in YouTube
        </Button>
      </Stack>
      <Box className="fn-live-frame">
        <iframe
          key={embedSrc}
          title="Final Night Live"
          src={embedSrc}
          width="100%"
          height="100%"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
          allowFullScreen
        />
      </Box>
    </Box>
  );
}

export { youtubeEmbedUrl };
export default memo(FinalNightLiveStream);
